import { render } from "./Oktell.vue?vue&type=template&id=328c2c6c&scoped=true&ts=true"
import script from "./Oktell.vue?vue&type=script&lang=ts"
export * from "./Oktell.vue?vue&type=script&lang=ts"

import "./Oktell.vue?vue&type=style&index=0&id=328c2c6c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328c2c6c"]])

export default __exports__